import { ComponentProps } from "react";

import { cn } from "@/utils/cn";

export const BrandText = ({ className, ...props }: ComponentProps<"span">) => {
  return (
    <span
      className={cn(
        "text-royal-500 transition-all duration-200 dark:text-gold-500",
        className,
      )}
      {...props}
    />
  );
};
